import { useCallback } from 'react';
import * as cookie from 'app/libs/cookie';
import { useSsrRequest } from 'app/context/common/SsrRequestProvider';
import { isServer } from 'app/libs/environment';

// SSR시 요청정보(req.headers.cookie)를 이용하는 쿠키 custom hook
function useSsrCookie() {
	const req = useSsrRequest();
	const getCookie = useCallback(
		(key) => {
			const cookieStr = isServer ? req.headers.cookie : window.document.cookie;
			return cookie.getCookie(key, cookieStr);
		},
		[req],
	);

	return {
		getCookie,
		setCookie: cookie.setCookie,
		deleteCookie: cookie.deleteCookie,
	};
}

export default useSsrCookie;
